import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InstructionFormat, InstructionLanguage } from '../../../shared/services/instruction-pdf.service';

export interface InstructionOptionsDialogData {
  mode: 'single' | 'bulk';
}

export interface InstructionOptionsResult {
  language: InstructionLanguage;
  format: InstructionFormat;
}

@Component({
  selector: 'app-instruction-options',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, DropdownModule, SelectButtonModule],
  templateUrl: './instruction-options.component.html',
  styleUrl: './instruction-options.component.scss',
})
export class InstructionOptionsComponent implements OnInit {
  private _dialogRef = inject(DynamicDialogRef);
  private _dialogConfig = inject(DynamicDialogConfig);
  private _fb = inject(FormBuilder);

  public mode: 'single' | 'bulk' = 'bulk';
  public optionsForm!: FormGroup;

  public readonly languages: { code: InstructionLanguage; name: string }[] = [
    { code: 'pl', name: 'Polski' },
    { code: 'uk', name: 'Ukraiński' },
    { code: 'en', name: 'Angielski' },
  ];

  public readonly formats: { value: InstructionFormat; label: string }[] = [
    { value: 'A5', label: 'Email (A5)' },
    { value: 'A4', label: 'Wysyłka (A4)' },
  ];

  ngOnInit(): void {
    const data = this._dialogConfig.data as InstructionOptionsDialogData | undefined;
    this.mode = data?.mode ?? 'bulk';
    this.optionsForm = this._fb.group({
      language: ['pl'],
      format: ['A5'],
    });
  }

  cancel(): void {
    this._dialogRef.close();
  }

  confirm(): void {
    const result: InstructionOptionsResult = {
      language: this.optionsForm.value.language,
      format: this.mode === 'bulk' ? this.optionsForm.value.format : 'A5',
    };
    this._dialogRef.close(result);
  }
}
